import {
	Menu,
	MenuList,
	MenuOpenChangeData,
	MenuOpenEvent,
	MenuPopover,
	MenuTrigger,
	mergeClasses,
} from "@fluentui/react-components";
import { MenuViewProps } from ".";
import { useStyle } from "../menu/style";
import { useState } from "react";

export const MenuView = (props: MenuViewProps) => {
	const style = useStyle();

	const [menuOpen, setMenuOpen] = useState(false);

	const handleOpenChange = (_: MenuOpenEvent, data: MenuOpenChangeData) => {
		setMenuOpen(data.open);
	};

	return (
		<Menu
			hasIcons
			inline
			aria-modal="false"
			positioning={props.positioning}
			hoverDelay={0}
			closeOnScroll={true}
			onOpenChange={handleOpenChange}
			open={menuOpen}
		>
			<MenuTrigger disableButtonEnhancement>{props.trigger}</MenuTrigger>
			<MenuPopover
				className={mergeClasses(style.menuPopoverContainer, props.menuPopoverClasses)}
				onMouseLeave={() => setMenuOpen(false)}
			>
				<MenuList>{props.content}</MenuList>
			</MenuPopover>
		</Menu>
	);
};
